<template>
  <div class="pageContent">
    <pageTitle title="我的收藏" />
    <div style="height:0.2rem"></div>


    <div style=" width:100% " align="center" v-show="  IsLoading  " >
      <img src="../../../static/LoadingGrey.gif" style=" width:1.2rem ; margin:2.1rem auto 0 auto"  />
    </div>

  
    <div style=" background-color: white " v-for="item in list" align="center"   v-show="  !IsLoading  ">
      <table style="  width:92% ; text-align:left ; " border="0"    >
        <tr>
          <td style=" width:1.2rem;" rowspan="4" v-on:click="gohotel(item.HotelCode)"  >
            <!--酒店图片-->
            <!--<img src="../../../static/order/LOGO_021003_4.jpg" style=" width:1rem;  margin: 0 0 0 0rem;" />-->
            <img v-bind:src="item.Logo!=''?item.Logo:'../../../static/search/noImg.jpg' " style=" width:1rem;  margin: 0 0 0 0rem;" />
          </td>
          <td style="  color:#666666 ; font-weight:bold ; " v-on:click="gohotel(item.HotelCode)"   >
            <div style="margin-top:1vh;">
              <!--格林豪泰上海市长风公园贝壳公寓酒店-->
              {{item.HotelName}}
            </div>
          </td>
          <td style="width:15% ; " align="center" rowspan=2>
            <div style="  border: 1px solid #DCDCDC ; padding:0.1rem " v-on:click="deleteitem(item.HotelCode)">
              <div style="font-size:0.22rem ; ">
                删除
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td style="">
            <div style="margin-bottom:1vh ; ">
              <img src="../../../static/order/position.png" style="height:11px " />
              <!--普陀区曹杨路154弄60号-->
              {{item.Address}}
            </div>
          </td>
        </tr>
      </table>
      <mu-divider/>
    </div>
    <!--列表尾巴-->
    <loadListTail mainTitle='暂无收藏，添加收藏下次查找更方便哦！' mainIcon='noCollect' :extendBtn='true' @btnHandler='goHome' :noMore='true' :isLoading='IsLoading' :overZero='list.length > 0'  />
    <br />
    <br />
    <br />
    <br />
    <!--弹出框 选择是否-->
    <mu-dialog :open="dialog" title="" @close="closeNO">
      <div style="color:#666666 ; margin-bottom:1.5vh">
        您真的要删除这条收藏吗？
      </div>
      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO" primary="" label="取消" style="background-color:#cccccc ;color:white  " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES" label="确定" style="background-color:#27BA69 ;;color:white " />
          </td>
        </tr>
      </table>
    </mu-dialog>
    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />
  
  </div>
</template>







<script>

import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'
import loadListTail from '../../components/loadListTail'

export default {
  data() {

    return {

      IsLoading: true,

      // 弹出层
      toast: false,
      TellUser: '',
      // 弹出标签 选择是否
      dialog: false,

      list: [],

      hotelCode: '',
      cardno: '',

    }
  },
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_currentInfo'
    ])
  },
  // watch: {
  //   //点入此页面，刷新用户名。名字变化了，说明换用户了。之前名字为空，说明页面没有缓存，不需要重复重载。
  //   $route(to, from) {
  //     // 算了，进了页面就重新获取吧
  //     if (to.path == "/user/MyCollection") {
  //       this.list = [];
  //       this.getMyHotel();
  //     }
  //   },
  // },
  activated() {
    this.IsLoading = true;
    this.list = [];
    this.getMyHotel();
  },
  components: {
    loadListTail
  },
  methods: {
    ...mapMutations([
      'setG_currentInfo', 'setG_searchParam'
    ]),

    getMyHotel() {
      this.$http.post(api.getMyHotel()).then((res) => {
        console.log(res);

        if (res.Result) {
          this.list = res.Data;
          this.IsLoading = false;
        }
        else {
          //调用弹出层
          this.TellUser = res.Message;
          this.showToast();
        }

      })
    },

    // 后退一页
    goback() {
      javascript: history.go(-1);
    },



    gohotel(code) {

      var params = new this.URLSearchParam();
      params.append('hotelCode', code);
      this.$http.post(api.getHotelDetail(),params.toParam()).then((res) => {
        if(res.Result){
          //console.log(res.Data)
          this.setG_currentInfo(res.Data);
        }
      })

      var model = this.g_currentInfo;
      //修改酒店编码
      model.hotelCode = code;
      this.setG_currentInfo(model);
      this.$router.push({ path: '/search/homeList' });
      console.log( this.g_currentInfo.hotelCode )
    },




    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser =='未登录'){
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end
    // 弹出标签 选择是否
    deleteitem(val) {
      this.dialog = true;
      this.hotelCode = val;
    },
    closeYES() {
      this.dialog = false;

      var params = new this.URLSearchParam();
      params.append('hotelCode', this.hotelCode);

      this.$http.post(api.DeleteMyHotel(), params.toParam()).then((res) => {
        console.log(res);
        //调用弹出层
        this.TellUser = res.Data;
        this.showToast();

        this.getMyHotel();

      });
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },
    // END 弹出标签 选择是否
    goHome(){
      this.$router.push({ path: '/home/index' });
    }
  }
}



</script>




<style lang="less" scoped="">
@import "../../assets/theme.less";



#greenfont {
  color: @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  background-color: #F5F5F5;
  min-height: 110vh

}
</style>








// WEBPACK FOOTER //
// MyCollection.vue?6a64f032